module.exports = __webpack_public_path__ + "static/media/filter.b5bc633a.svg";